export default "__VITE_ASSET__ClyLrQWT__"